<script lang="ts">
  /** Where a claim came from. Public facts get numbered sources. Analysis keeps
   *  its warning label AND the public footnotes it rests on; hiding those made
   *  "Inference" a dead-end. Internal claims can jump to their held record. */
  import type { Provenance, RenderCtx, Source } from './types';

  let { provenance, sourceIds = [], ctx }: {
    provenance?: Provenance;
    sourceIds?: string[];
    ctx: RenderCtx;
  } = $props();

  const notes = $derived(sourceIds
    .map(id => ({ id, n: ctx.footnotes.get(id) }))
    .filter((x): x is { id: string; n: number } => x.n !== undefined));
  const internal = $derived(sourceIds
    .map(id => ctx.sources.find(source => source.id === id))
    .filter((source): source is Source => !!source && source.kind !== 'public'));
  function showInternal() {
    if (internal.length === 1 && internal[0].message_id && ctx.onOpenSource)
      ctx.onOpenSource(internal[0]);
    else if (internal[0]) ctx.onFootnote?.(internal[0].id);
  }
</script>

{#if provenance === 'public'}{#each notes as note, i (note.id)}<a
  class="brf-fn" class:cont={i > 0} href="#{ctx.idPrefix}-{note.id}"
  aria-label="Source {note.n}" title={ctx.sources.find(s => s.id === note.id)?.label}
  onclick={(event) => { event.preventDefault(); ctx.onFootnote?.(note.id); }}>{note.n}</a>{/each}{:else if provenance === 'relationship'}{#if internal.length && ctx.onFootnote}<button
  type="button" class="brf-tag rel" onclick={showInternal}
  aria-label="Internal source: {internal[0]?.label}" title="Open the internal source">Internal</button>{:else}<span
  class="brf-tag rel" title="From held email, meeting, note, or workspace data">Internal</span>{/if}{:else if provenance === 'inference'}{#if internal.length && ctx.onFootnote}<button
  type="button" class="brf-tag inf" onclick={showInternal}
  aria-label="Analysis: open supporting internal source"
  title="Analysis derived from evidence; open the supporting internal source">Analysis</button>{:else}<span
  class="brf-tag inf" title="Analysis derived from evidence; not directly stated">Analysis</span>{/if}{#each notes as note, i (note.id)}<a
  class="brf-fn" class:cont={i > 0} href="#{ctx.idPrefix}-{note.id}"
  aria-label="Source {note.n}" title={ctx.sources.find(s => s.id === note.id)?.label}
  onclick={(event) => { event.preventDefault(); ctx.onFootnote?.(note.id); }}>{note.n}</a>{/each}{/if}
